module.exports = __webpack_public_path__ + "static/img/back.fed5ba8f.png";